module.exports = __webpack_public_path__ + "img/attachment-filling.da0448d7.svg";